import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText, FormLabel } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import RichTextEditor from 'react-rte';
import DialogLoader from '../../../../components/Loader/DialogLoader';

import { InputBaseField, SelectField, CheckboxField } from '../../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'
import { GetDataAPI } from '../../../../Services/GetDataAPI';
import { PostDataAPI } from '../../../../Services/APIService';
import { withSnackbar } from "./../../../../components/Message/Alert";
import useStyles from "./styles";
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";
function AddNewRole({ dialogOpenClose, handleClose, handleSuccessClose, data, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [rolePermission, setRolePermission] = useState([]);
    const [saveRolePermission, setSaveRolePermission] = useState([]);
    const [role, setRole] = useState({
        roleId: 0, roleName: "", parentRightId: 0, roleDescription: "", accesPermission: 2, createdBy: 0, createDate: new Date().toISOString(), updatedBy: 0,
        userRights: []
    });
    const [errorMessages, setErrorMessages] = useState({
        errorNote: false,
        errorEditorMaxValue: false,
    })

    const accessPermissionEnum = {
        NOTVISIBLE: 0,
        NOTEDITABLE: 1,
        EDITABLE: 2
    };

    const { showMessage } = props;
    const handleChange = e => {
        const { name, value } = e.target;
        setRole(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }
    const Validate = (errorList) => {

        if (!role.roleName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRoleName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRoleName: false
            }));
        }

        if (!role.roleDescription) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRoleDescription: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRoleDescription: false
            }));
        }
        if (!role.landingPage) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLandingPage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLandingPage: false
            }));
        }
    }
    const handleChangeRight = e => {
        const { name, value } = e.target;
        debugger;
        let permissionList;
        var lstRolePermission = rolePermission;

        var _index = name.split('_');
        
        //Case: Hidden
        if (_index[2] == "0") {

            lstRolePermission[_index[1]].isHidden = true;
            lstRolePermission[_index[1]].isReadOnly = false;
            lstRolePermission[_index[1]].isEditable = false;
            //parent node checked
            if (lstRolePermission[_index[1]].parentRightId != null && lstRolePermission[_index[1]].parentRightId <= 0) {
                lstRolePermission.map((item) => {
                    if (item.parentRightId == lstRolePermission[_index[1]].rightId) {
                        item.isHidden = true;
                        item.isReadOnly = false;
                        item.isEditable = false;
                    }
                });
            }
            //child node checked
            if (lstRolePermission[_index[1]]?.parentRightId > 0) {
                let childNodes = lstRolePermission.filter(a => a.parentRightId == lstRolePermission[_index[1]]?.parentRightId);
                if (childNodes.every(t => t.isHidden)) {
                    lstRolePermission.map((item) => {
                        if (item.rightId == lstRolePermission[_index[1]].parentRightId) {
                            item.isHidden = true;
                            item.isReadOnly = false;
                            item.isEditable = false;
                        }
                    });
                }

            }
            permissionList = lstRolePermission;

        }
        else if (_index[2] == "2") { //Case: Visible

            lstRolePermission[_index[1]].isHidden = false;
            lstRolePermission[_index[1]].isReadOnly = false;
            lstRolePermission[_index[1]].isEditable = true;
            if (lstRolePermission[_index[1]].parentRightId != null && lstRolePermission[_index[1]].parentRightId <= 0) {
                lstRolePermission.map((item) => {
                    if (item.parentRightId == lstRolePermission[_index[1]].rightId) {
                        item.isHidden = false;
                        item.isReadOnly = false;
                        item.isEditable = true;
                    }
                })
            }
            //child node checked
            if (lstRolePermission[_index[1]]?.parentRightId > 0) {
                let childNodes = lstRolePermission.filter(a => a.parentRightId == lstRolePermission[_index[1]]?.parentRightId);
                //if (childNodes.every(t => t.isEditable)) {
                lstRolePermission.map((item) => {
                    if (item.rightId == lstRolePermission[_index[1]].parentRightId) {
                        item.isHidden = false;
                        item.isReadOnly = false;
                        item.isEditable = true;
                    }
                });
                // }

            }
            permissionList = lstRolePermission;
        }

        setSaveRolePermission(prevrole => ({
            ...prevrole,
            saveRolePermission: lstRolePermission
        }));

        setRole(prevState => ({
            ...prevState,
            userRights: permissionList
        }));
        debugger;
        if (role?.landingPage == _index[0]) {
            setRole(prevState => ({
                ...prevState,
                'landingPage': ''
            }));
        }
        const filteredRoleLandingPages = roleLandingPages.filter(page => {
            return !lstRolePermission.some(permission => permission.rightName === page.value && permission.rightId == page.rightId && permission.isHidden);
        });
        setFilteredRoleLandingPages(filteredRoleLandingPages);

    };
    function loadData(landingPageOpts) {
        //let _roleId = roleId && roleId > 0 ? roleId : parseInt(data.roleId);
        setIsLoading(true);
        GetDataAPI("fdnrole/getRoleRightsPermissionsByID", 'id=' + parseInt(data.roleId)).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
               

                setRole(prevState => ({
                    ...prevState,
                    roleId: result.data.roleId,
                    roleName: result.data.roleName,
                    parentRightID: result.data.parentRightID,
                    roleDescription: result.data.roleDescription,
                    accesPermission: result.data.accesPermission,
                    landingPage: result.data.landingPage
                }));
                var lstRolePermission = result.data.userRights.map((item, i) => {
                    return {
                        rightId: item.rightId,
                        rightName: item.rightName,
                        rightLabel: item.rightLabel,
                        isHidden: item.isHidden,
                        isReadOnly: item.isReadOnly,
                        isEditable: item.isEditable,
                        roleAccessRightId: item.roleAccessRightId,
                        roleId: result.data.roleId,
                        createDate: item.createDate,
                        parentRightId: item.parentRightId
                    };
                });
                setRolePermission(lstRolePermission);
                const filteredRoleLandingPages = landingPageOpts.filter(page => {
                    return !lstRolePermission.some(permission => permission.rightName === page.value && permission.rightId == page.rightId && permission.isHidden);
                });
                setFilteredRoleLandingPages(filteredRoleLandingPages);


            }
            else if (result.message) {
                showMessage("Error", result.message, "error", 3000);
            }
        })

    }
    function setFormrole(landingPageOpts) {
        if (data.roleId > 0) {
            role.roleId = data.roleId;
            role.roleName = "";
            role.parentRightID = 0;
            role.roleDescription = "";
            loadData(landingPageOpts);
        }
        else {
            setFilteredRoleLandingPages(landingPageOpts);
            setRole({
                roleId: 0, roleName: "", parentRightID: 0, roleDescription: "", accesPermission: 2, createdBy: 0,
                createDate: new Date().toISOString(), updatedBy: 0, userRights: []
            });
            var params = { roleType: 'te' };
            setIsLoading(true);
            PostDataAPI("fdnrole/getRightsPermissions", params, true, '').then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    // console.log(result.data);

                    setRolePermission(
                        result.data.map((item, i) => {
                            return {
                                rightId: item.rightId,
                                rightName: item.rightName,
                                rightLabel: item.rightLabel,
                                isHidden: item.isHidden,
                                isReadOnly: item.isReadOnly,
                                isEditable: item.isEditable,
                                parentRightId: item.parentRightId,
                                rightCode: item.rightCode
                            };
                        }));
                    setRole(prevState => ({
                        ...prevState,
                        userRights: result.data.map((item, i) => {
                            return {
                                rightId: item.rightId,
                                rightName: item.rightName,
                                rightLabel: item.rightLabel,
                                isHidden: item.isHidden,
                                isReadOnly: item.isReadOnly,
                                isEditable: item.isEditable,
                                parentRightId: item.parentRightId,
                                accesPermission: item.accesPermission,
                                rightCode: item.rightCode
                            };
                        })
                    }));
                }

            });
        }
    }
    const postRequest = (method) => {
        setIsLoading(true);

        PostDataAPI(method, role, true, '').then((result) => {
            setIsLoading(false);

            if (result.success == true) {

                setErrorMessages([]);
                if (result.data.isRoleNameExists) {
                    showMessage("Error", "Role name already exists.", "error", 3000);
                }
                //else if (result.data == false) {
                //    showMessage("Error", "Something went wrong, please check role name is not unique.!", "error", 3000);
                //}
                else {
                    if (data.roleId > 0) {
                        handleSuccessClose("Role updated successfully.");

                        //showMessage("success", "Record saved successfully.", "success", 3000);
                    } else {
                        handleSuccessClose("Role saved successfully.");
                        //showMessage("success", "Record updated successfully.", "success", 3000);
                    }

                    role.userRights = [];
                    //role.roleID = result.data.roleID

                }
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);

        })
    }
    const addRole = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            let method = "fdnrole/add";
            if (data.roleId > 0) {
                role.roleID = parseInt(data.roleId);
                role.roleName = role.roleName.trim();
                method = "fdnrole/update";
                showActionDialog("Warning: Updating this role can impact the user rights associated with this role. Are you sure you want to update?", "confirm", function () {
                    postRequest(method);
                });
            }
            else {
                postRequest(method);
            }
        }
    }
    const [roleLandingPages, setRoleLandingPages] = useState([]);
    const [filteredRoleLandingPages, setFilteredRoleLandingPages] = useState([]);
    const initializations = () => {
        var params = {
            code: "get_landing_pages",
            parameters: ['']
        };
        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {
                const defaultOption = { value: '', label: 'Select Landing Page' };
                const landingPageOptions = [defaultOption, ...result.data.map(item => ({
                    value: item.text1,
                    label: item.text2,
                    rightId:item.text3
                }))];
                setRoleLandingPages(landingPageOptions);
                setFormrole(landingPageOptions);
                //setFilteredRoleLandingPages(landingPageOptions);
                //result.data.map((item, i) => {
                //    setRoleLandingPages(prevState => [...prevState, { value: item.text1, label: item.text2 }]);
                //    setFilteredRoleLandingPages(prevState => [...prevState, { value: item.text1, label: item.text2 }]);
                //})
            }
        })
    }
    useEffect(() => {
        initializations();
        //setFormrole();
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props} >
            {isLoading ? <DialogLoader></DialogLoader> : ''}
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{role.roleId > 0 ? 'Update User Role' : 'Add User Role'}</Typography>

                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>



                    <Scrollbars autoHeight autoHeightMax={450}>
                        <div className={classes.content}>
                            <Grid container spacing={4}>
                                <Grid item sm={12} md={6} lg={6} xl={6} >
                                    <Label size={12} title="Role Name" mandatory={true} />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <InputBaseField
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            value={role.roleName}
                                            onChange={handleChange}
                                            placeholder='Role Name'
                                            //IsDisabled={role.accesPermission === accessPermissionEnum.EDITABLE ? false : true}
                                            MaxLength={50}
                                        />
                                        {errorMessages.errorRoleName && !role.roleName ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter role name
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>
                                <Grid item sm={12} md={6} lg={6} xl={6}>
                                    <Label size={12} title="Description" mandatory={true} />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <InputBaseField
                                            id="roleDescription"
                                            name="roleDescription"
                                            type="text"
                                            value={role.roleDescription}
                                            onChange={handleChange}
                                            placeholder='Description'
                                            //IsDisabled={role.accesPermission === accessPermissionEnum.EDITABLE ? false : true}
                                            MaxLength={100}
                                        />
                                        {errorMessages.errorRoleDescription && !role.roleDescription ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter role description
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>

                            </Grid>
                            <Grid container spacing={4}>

                                <Grid item sm={12} md={6} lg={6} xl={6}>

                                    <Label title="Landing Page" size={12} mandatory={true} />
                                    <Grid item lg={12} md={12} sm={12}>
                                        <Select
                                            size="small"
                                            native
                                            name="landingPage"
                                            value={role?.landingPage}
                                            onChange={handleChange}
                                            placeholder="Select"
                                            label="Select"
                                            className={classes.selectBaseInput}
                                        >
                                            {filteredRoleLandingPages.map(option =>
                                                <option value={option.value}>{option.label}</option>
                                            )
                                            }
                                        </Select>
                                        {errorMessages.errorLandingPage && !role?.landingPage ? (<FormHelperText style={{ color: "red" }} >
                                            Please select landing page
                                        </FormHelperText>) : ('')}
                                    </Grid>

                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} container direction="row" justify="center" style={{ marginTop: '15px' }}>

                                <Grid id="header" className={classes.paperTop} item container xs={12} lg={12} direction="row">

                                    <Grid className={classes.paperHeading} item xs={6} sm={6} md={6} lg={6}>
                                        <FormLabel className={classes.trHeaderLabel} style={{ padding: '0px 12px' }}>Permissions</FormLabel>
                                    </Grid>
                                    <Grid className={classes.paperHeading} item xs={3} sm={3} md={3} lg={3}>
                                        <FormLabel className={classes.trHeaderLabel}>Hidden</FormLabel>
                                    </Grid>
                                    {/*<Grid className={classes.paperHeading} item xs={2} sm={2} md={2} lg={2}>*/}
                                    {/*    <FormLabel className={classes.trHeaderLabel}>Read only</FormLabel>*/}
                                    {/*</Grid>*/}
                                    <Grid className={classes.paperHeading} item xs={3} sm={3} md={3} lg={3}>
                                        <FormLabel className={classes.trHeaderLabel}>Visible</FormLabel>
                                    </Grid>

                                </Grid>

                                {
                                    rolePermission ?
                                        rolePermission.map((item, i) => (
                                            <Grid item xs={12} lg={12} container direction="row" key={i}>

                                                <Grid item container xs={6} sm={6} md={6} lg={6} alignItems="center" className={classes.gridRowBottomLeft}>
                                                    {item.parentRightId > 0 ?
                                                        <FormLabel className={classes.griLabelChild}>{item.rightLabel}</FormLabel>
                                                        : <FormLabel className={classes.griLabel}>{item.rightLabel}</FormLabel>
                                                    }

                                                </Grid>

                                                <Grid item xs={3} sm={3} md={3} lg={3} className={classes.gridRowBottom}>
                                                    <CheckboxField
                                                        color="primary"
                                                        name={item.rightName + "_" + i + "_0" + "_" + item.rightId}
                                                        checked={rolePermission[i].isHidden}
                                                        onChange={handleChangeRight}

                                                    />
                                                </Grid>

                                                {/*<Grid item xs={2} sm={2} md={2} lg={2} className={classes.gridRowBottom}>*/}
                                                {/*    <CheckboxField*/}
                                                {/*        color="primary"*/}
                                                {/*        name={item.right_name + "_" + i + "_1"}*/}
                                                {/*        checked={item.right_name === 'dashboard' && item.parentRightId === 0 ? false : rolePermission[i].isReadOnly}*/}
                                                {/*        onChange={handleChangeRight}*/}
                                                {/*        IsDisabled={item.right_name === 'dashboard' && item.parentRightId === 0 ? true : false}*/}
                                                {/*    />*/}
                                                {/*</Grid>*/}

                                                <Grid item xs={3} sm={3} md={3} lg={3} className={classes.gridRowBottomRight} >
                                                    <CheckboxField
                                                        color="primary"
                                                        name={item.rightName + "_" + i + "_2" + "_" + item.rightId}
                                                        checked={rolePermission[i].isEditable}
                                                        onChange={handleChangeRight}
                                                    />
                                                </Grid>

                                            </Grid>

                                        ))
                                        : null
                                }

                            </Grid>

                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={addRole}>{role.roleId > 0 ? 'Update' : 'Add New'}</Button>

                        </div>
                    </div>
                </div>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </Dialog >
    )
}

export default withSnackbar(AddNewRole);
